import React from 'react'
import Grid from '../../components/grid/Grid'
import "./grid.css"

const GridPage = () => {
  return (
    <div className='grid'>
        <Grid/>
    </div>
  )
}

export default GridPage